<template>
  <el-row>
    <el-col
      :span="11"
      v-for="(o, index) in newslist"
      :key="index"
      :offset="index > 0 ? 2 : 0"
    >
      <el-card id="control-card">
        <el-col :span="6">
          <img src="../assets/bp1.png" class="image" />
        </el-col>
        <el-col :span="18" id="control-left1">
          <router-link :to="'/active/' + o.id" id="text"
            ><a href="#"
              ><h3>{{ o.title }}</h3></a
            ></router-link
          >
          <p v-html="o.content"></p>
        </el-col>
      </el-card>
    </el-col>
    <br />
  </el-row>
</template>

<script>
import getArticleList from "../utils/getArticleList";
export default {
  name: "Intro1",
  data() {
    return {
      msg:
        "深圳市华银精治资产管理公司是中国顶尖的私募资产管理机构，中国基金业协会首批特别会员，前海股权交易中心首批挂牌企业。目前华银精治管理近百只基金，规模30亿元，投资业绩排列全国前茅，获得2016年和2015年全国私募业绩排名冠军。",
      newslist: []
    };
  },
  created() {
    getArticleList(
      this.$http,
      "/huayin/get-articles",
      "",
      "新闻中心",
      "1",
      "2"
    ).then(articleList => {
      this.newslist = articleList.data.data;
      console.log(this.newslist);
    });
  }
};
</script>

<style scoped>
.time {
  font-size: 13px;
  color: #999;
}

.el-row {
  margin: 0 auto;
  margin-top: 1%;
  width: 80%;
  margin-bottom: 20px;
  height: 100%;
  position: relative;
}

#control-left1 {
  padding-left: 3%;
}

.image {
  width: 100%;
  height: 100px;
  margin-bottom: 10%;
}
#control-card {
  height: 220px;
}
</style>



// WEBPACK FOOTER //
// src/components/intro1.vue